// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"dcd9bacb","154":"ba74c282","204":"0b5e01e1","227":"de4e224a","298":"de833552","564":"3b72ba2b","588":"242d04a6","658":"a77aa7c7","689":"41b909ca","691":"a2972772"}[chunkId] + ".chunk.js";
};